// extracted by mini-css-extract-plugin
module.exports = {"description":"Step_description__tjeER","inactiveSlide":"Step_inactiveSlide__0VbSY"};